import token from '../../../api/token'
import router from '../../../routes'
import * as errorMessages from '../../../error-messages'

export default {
  async clearAll({commit}){
    commit('clearAll')
    commit('forms/login/resetErrors')
  },

  async loginWithTokens({commit, state, dispatch}, data){
    const redirect = data.redirectUrl ?  {path: data.redirectUrl} : {name: 'home'}

    try {
      commit('forms/login/setSaving', true)

      commit('setTokenDataFromAPI', data)
      await dispatch('client/getMe', null, {root:true})
      dispatch('config/index', null, {root:true})

      router.push(redirect)
      return 'ok'

    } catch (err) {
      return err
    } finally {
      commit('forms/login/setSaving', false)
    }
  },

  async login({commit, state, dispatch}) {
    commit('forms/login/resetErrors')

    const data = {
      email: state.forms.login.fields.email,
      password: state.forms.login.fields.password
    }

    const redirect = state.forms.login.fields.redirectUrl ?  {path: state.forms.login.fields.redirectUrl} : {name: 'home'}

    try {
      commit('forms/login/setSaving', true)
      const resp = await token.login(data)

      commit('setTokenDataFromAPI', resp.data)
      await dispatch('client/getMe', null, {root:true})
      dispatch('config/index', null, {root:true})

      commit('forms/login/resetFields')

      router.push(redirect)
      return 'ok'

    } catch (err) {
      if (err.response) {
        if (err.response.status === 422) {
          const errors = err.response.data.errors
          commit('forms/login/setErrors', errors)

        } else if (err.response.status === 401) {
          if (/suspended/.test(err.response.data.message)) {
            commit('forms/login/setFieldErrors', {
              field: 'other',
              errors: [errorMessages.SUSPENDED]
            })

          } else {
            commit('forms/login/setFieldErrors', {
              field: 'other',
              errors: [errorMessages.INVALID_CREDENTIALS]
            })
          }

        } else if (err.response.status === 429) {
          commit('forms/login/setFieldErrors', {
            field: 'other',
            errors: [errorMessages.TOO_MANY_ATTEMPTS]
          })
        }
      }
      return 'error'
    } finally {
      commit('forms/login/setSaving', false)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/token/actions.js